import Vue from 'vue';
import VueAirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import moment from 'moment';
// import 'vue-airbnb-style-datepicker/dist/styles.css'

var monthName = Array.apply(0, Array(12)).map(function (val, index) {
    return moment().month(index).format('MMMM');
});

Vue.use(VueAirbnbStyleDatepicker, {
    monthNames: this.monthName,
    colors: {
        selected: '#3490e7',
        inRange: '#287DF2',
        selectedText: '#fff',
        text: '#565a5c',
        inRangeBorder: '#1C6DDA',
        disabled: '#eee'
    },
    days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
    daysShort: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
    texts: {
        cancel: 'Borrar selección',
        apply: 'Aceptar'
    }
});

// export default (ctx, inject) => {
//     inject('VueAirbnbStyleDatepicker',  VueAirbnbStyleDatepicker)
// }


//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-airbnb-style-datepicker.js
// module id = ./src/plugins/vue-airbnb-style-datepicker.js
// module chunks = 34